<template>
  <div>
    <h3 class="my-4">{{$t('VR_function_list')}}</h3>
    <div class="my-5 list-box">
      <div v-if="this.$store.state.auth.userRole === 'Teacher'" class="menu-box" @click="goPage('vocabulary')">
        <p v-if="locale==='tw'">自訂單字任務</p>
        <p>Create vocabulary mission</p>
      </div>
      <div v-if="this.$store.state.auth.userRole === 'Teacher'" class="menu-box"  @click="goPage('conversation',0)">
        <p v-if="locale==='tw'">自訂對話任務</p>
        <p>Create conversation mission</p>
      </div>
      <div v-if="this.$store.state.auth.userRole === 'Teacher'" class="menu-box" @click="goPage('Classroom_record')">
        <p v-if="locale==='tw'">觀看使用紀錄</p>
        <p>Using record</p>
      </div>
      <div v-if="this.$store.state.auth.userRole === 'Teacher'" class="menu-box" @click="goPage('VR_classroom')">
        <p v-if="locale==='tw'">開始上課</p>
        <p>Start a new course</p>
      </div>
      <div v-if="this.$store.state.auth.userRole === 'Teacher'" class="menu-box" @click="goPage('VR_resource')">
        <p v-if="locale==='tw'">教用資源</p>
        <p>Learning Resources</p>
      </div>
      <div v-if="this.$store.state.auth.userRole === 'Teacher'" @click="createSerialCode" class="menu-box">
        <p v-if="locale==='tw'">產生登入序號</p>
        <p>Create serial number</p>
      </div>

      <div v-if="this.$store.state.auth.userRole === 'Student'" class="menu-box" @click="goPage('VR_record',$store.state.auth.user.id)">
        <p v-if="locale=='tw'">觀看使用紀錄</p>
        <p>Using record</p>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../../store/api.js'
import swal from 'bootstrap-sweetalert'
export default {

  name: 'VRIndex',

  data () {
    return {
      locale: window.localStorage.getItem('locale')
    }
  },
  mounted () {
  },
  methods: {
    goPage (link, id) {
      this.$router.push({name: link, params: { id: id }})
      console.log(link, id)
      // this.$emit('updateTags', link)
    },
    createSerialCode () {
      swal({
        title: this.$t('reminder'),
        text: this.$t('serial_number_rule'),
        type: 'info',
        showCancelButton: true,
        closeOnConfirm: false
      }, async () => {
        let formData = new window.FormData()
        formData.append('userIds', this.$store.state.auth.user.id)
        const { data } = await api.post(`/VR/AccessCode`, formData)
        swal({
          title: this.$t('success_serial_number'),
          text: `${this.$t('your_serial_number')}:${data.data[0].accessCode} \n${this.$t('valid_until')}:${data.data[0].expreTime}`
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/style/color.scss";
  .list-box {
    width: 60%;
    margin: auto;
  }
  .menu-box {
    cursor: pointer;
    text-align: left;
    background-color: #fff;
    border-radius: 10px;
    border: 1.5px solid #6666;
    margin: 10px auto;
    padding: 10px 20px;
    p {
      margin: 0;
    }
      &:hover {
      box-shadow:0px 0px 8px #a1a1a1;
    }
  }
</style>


// WEBPACK FOOTER //
// VRIndex.vue?0a10139c